import React from 'react';
import { ResizableTextArea } from '@td-client-frontend/common';
import ComponentWrapperRHF from './ComponentWrapperRHF';

interface Props {
  name: string;
  maxHeight?: number;
  readOnly?: boolean;
  styles?: string;
  wrapperClasses?: string;
  className?: string;
}

export const ResizableTextAreaRHF = ({ ...props }: Props) => {
  return (
    <ComponentWrapperRHF {...props}>
      <ResizableTextArea />
    </ComponentWrapperRHF>
  );
};
